<template>
  <!-- 主页导航 -->
  <div class="nav">
    <!-- logo图片 -->
    <a href="index.html">
      <img src="../assets/images/logo/logo-feiyin.png" alt="" />
    </a>

    <ul>
      <li :class="{ liActive: liActiveNum == 1 }" @click="aboutUs">
        关于我们
      </li>
      <li :class="{ liActive: liActiveNum == 2 }" @click="contactUs">
        联系我们
      </li>
      <li>
        <!-- 音乐文件 -->
        <div
          class="on_music"
          @click="ctrl_music"
          :class="{ play: music_stop, pause: !music_stop }"
        >
          <i class="iconfont icon-iconset0163 li_changpian"></i>
        </div>
        <audio id="bg_music" src="../assets/feiyin-op.mp3"></audio>
      </li>
    </ul>
  </div>
</template>

<script>
// 引入总线
import { Bus } from "../bus";
export default {
  data() {
    return {
      music_stop: false,
      liActiveNum: 0
    };
  },
  methods: {
    // 控制点击音乐的暂停和播放效果
    ctrl_music() {
      let bg_music = document.querySelector("#bg_music");
      if (bg_music.paused) {
        bg_music.play();
        this.music_stop = true;
      } else {
        bg_music.pause();
        this.music_stop = false;
      }
    },
    aboutUs() {
      this.liActiveNum = 1;
      // 提交用户点击的id到总线
      Bus.$emit("liActiveNum", this.liActiveNum);
    },
    contactUs() {
      this.liActiveNum = 2;
      // 提交用户点击的id到总线
      Bus.$emit("liActiveNum", this.liActiveNum);
    }
  },
  created() {
    // 获取总线中的isActiveNum的内容，判断当前文字是否高亮显示
    Bus.$on("liActiveNum", liActiveNum => {
      this.liActiveNum = liActiveNum;
    });
  }
};
</script>

<style scoped>
.nav {
  width: 80%;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  position: fixed;
  top: 0;
  padding-top: 70px;
  min-width: 1080px;
  z-index: 100;
}
.nav_move {
  position: fixed;
  top: 0;
}
img {
  width: 9rem;
  margin-left: 2rem;
}
.nav ul {
  list-style: none;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  margin-right: 5%;
  width: 14vw;
  min-width: 170px;
}
.nav ul li {
  cursor: pointer;
}
.nav ul li:hover {
  font-weight: bold;
}
.liActive {
  font-weight: bold;
}
a {
  text-decoration: none;
  color: #fff;
}
.on_music {
  border: 1px solid #fff;
  border-radius: 50%;
  width: 1.4rem;
  height: 1.4rem;
  text-align: center;
  cursor: pointer;
  line-height: 1.4rem;
}
.on_music:hover {
  box-shadow: 0 0 0 0.5px #fff;
  -webkit-animation: music-round 2s linear infinite;
  animation: music-round 2s linear infinite;
}
.on_music .li_changpian {
  font-size: 1vw;
}
@-webkit-keyframes music-round {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes music-round {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.play {
  background: #fff;
  color: #161f2b;
  -webkit-animation: music-round 2s linear infinite;
  animation: music-round 2s linear infinite;
}
.pause {
  -webkit-animation: music-round 2s linear infinite paused;
  animation: music-round 2s linear infinite paused;
}
</style>
